import { render, staticRenderFns } from "./ClosingUserIcon.vue?vue&type=template&id=9f48983c&scoped=true"
import script from "./ClosingUserIcon.vue?vue&type=script&lang=js"
export * from "./ClosingUserIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f48983c",
  null
  
)

export default component.exports